import gql from 'graphql-tag';

export const GetCMSPostsForAdminQuery = gql`
  query GetCMSPostsForAdmin($filter: getPostsFilterInput, $order: getPostsSortFilterInput, $skip: Int, $take: Int) {
    getPosts(filter: $filter, order: $order, skip: $skip, take: $take) {
      posts {
        id
        type
        title
        subtitle
        content
        featuredImageUrl
        published
        publishedAt
        createdAt
        updatedAt
      }
      totalCount
      queryCount
    }
  }
`;

export default GetCMSPostsForAdminQuery;
